import * as z from 'zod';
import { Tag } from '../base-schemas';
import { ReservableResource } from './Reservable';
import { ReservableProductResource } from './ReservableProduct';
export const ReservableProductWithDetailsResource = z.object({
    _tag: Tag('ReservableProductWithDetailsResource'),
    product: ReservableProductResource,
    reservables: ReservableResource.array()
});
